var map = {
	"./icon-avatar.svg-sprite": "sAa6",
	"./icon-bookmark.svg-sprite": "3Y7T",
	"./icon-cancel.svg-sprite": "EpBV",
	"./icon-comment.svg-sprite": "Rzuk",
	"./icon-download.svg-sprite": "fONr",
	"./icon-eye.svg-sprite": "ef9N",
	"./icon-home.svg-sprite": "Mue+",
	"./icon-like.svg-sprite": "FlqL",
	"./icon-link.svg-sprite": "VJOX",
	"./icon-lock.svg-sprite": "qbfZ",
	"./icon-message.svg-sprite": "Xggb",
	"./icon-movie.svg-sprite": "Gn0U",
	"./icon-next.svg-sprite": "lWYa",
	"./icon-previous.svg-sprite": "SXjd",
	"./icon-search.svg-sprite": "yub8",
	"./icon-success.svg-sprite": "Yo5R",
	"./icon-upload.svg-sprite": "cln3",
	"./icon-view.svg-sprite": "7fZf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kqju";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/icons nonrecursive \.svg-sprite$
// module id = kqju
// module chunks = 0